import React, { useState, useEffect } from 'react';
import { Progress } from 'antd';

const FileProgress = props => {
	const { file } = props;
	const [progress, setProgress] = useState(0);
	function onProgressUpdate(percent) {
		setProgress(percent);
	}
	useEffect(() => {
		file.subscribeForProgress(onProgressUpdate);
	}, [file]);
	return (
		<Progress showInfo={false} percent={progress} size="default" />
	);
};

export default FileProgress;



// WEBPACK FOOTER //
// ./src/components/file-table/FileProgress.js